/**
 * WordPress dependencies
 */
import { BaseControl, Button, ColorIndicator, ColorPicker, Flex, FlexBlock, FlexItem, Popover } from '@wordpress/components';
import { withInstanceId } from '@wordpress/compose';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import classNames from 'classnames';

/**
 * Internal dependencies
 */

const ColorControl = ({ label, color, onChange, instanceId }) => {
    const [colorPanel, setColorPanel] = useState(false);

    const id = `color-control-${instanceId}`;

    // get colors from theme
    const COLORS = wp.data.select('core/editor').getEditorSettings().colors;

    return (
        <div className="progressmatify-control-container progressmatify-color-control progressmatify-mb-0">
            <Flex>
                <FlexBlock>
                    <BaseControl id={id} label={label} />
                </FlexBlock>
                <FlexItem>
                    <Button
                        icon="image-rotate"
                        label={__('Reset', 'progressmatify-blocks')}
                        onClick={() => onChange('')}
                        className={`progressmatify-reset-button ${color ? 'active' : 'disabled'}`}
                    />
                </FlexItem>
                <FlexItem>
                    <button className="color-indicator" onClick={() => setColorPanel(true)}>
                        <ColorIndicator colorValue={color} />
                    </button>
                    {colorPanel && (
                        <Popover position="bottom right" onFocusOutside={() => setColorPanel(false)} offset={10}>
                            <div className="progressmatify-color-panel">
                                <ColorPicker color={color} onChangeComplete={value => onChange(value.hex)} disableAlpha={false} />
                                <div className="progressmatify-colors-palette">
                                    <label className="progressmatify-label progressmatify-mb-8" htmlFor="progressmatify-colors-palette">
                                        {__('Theme Colors', 'progressmatify-blocks')}
                                    </label>
                                    <div id="progressmatify-colors-palette">
                                        {COLORS &&
                                            COLORS.map((paletteColor, index) => {
                                                return (
                                                    <ColorIndicator
                                                        className={classNames(
                                                            'progressmatify-color-indicator',
                                                            `${color === `var(--wp--preset--color--${paletteColor.slug})` ? 'active' : ''}`
                                                        )}
                                                        title={paletteColor.name}
                                                        key={index}
                                                        colorValue={paletteColor.color}
                                                        onClick={() => onChange(`var(--wp--preset--color--${paletteColor.slug})`)}
                                                    />
                                                );
                                            })}
                                    </div>
                                </div>
                            </div>
                        </Popover>
                    )}
                </FlexItem>
            </Flex>
        </div>
    );
};

export default withInstanceId(ColorControl);
